import { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Footer from "@/components/site/Footer";
import hero from "@/assets/hero-angkor.jpg";
import toursHero from "@/assets/tours-hero-lotus-bowl.png";
import angkorSunrise from "@/assets/visite-angkor-wat-cambodge.jpg";
import taprohm from "@/assets/tour-taprohm-tree.jpg";
import bayon from "@/assets/tour-kampong-kleang.jpg";
import banteay from "@/assets/tour-cambodia-sunset.jpg";
import phnomKulen from "@/assets/phnom-kulen-waterfall-tour.jpg";
import guide from "@/assets/guide-francophone-siem-reap.jpg";
import apsara from "@/assets/tour-apsara-relief.jpg";
import oxcart from "@/assets/tour-siem-reap-oxcart.jpg";
import taprohmTree from "@/assets/ta-prohm-temple-tour.jpg";
import beachSunset from "@/assets/tour-cambodia-beach-sunset.jpg";
import treeRoots from "@/assets/tour-cambodia-10day-treeroots.jpg";
import monks18 from "@/assets/tour-cambodia-18day-monks.jpg";
import beach21 from "@/assets/tour-cambodia-21day-beach.jpg";
import sunset25 from "@/assets/tour-cambodia-25day-sunset.jpg";
import siemReap2 from "@/assets/tour-siem-reap-2day-angkor-face.jpg";
import banteaySrei from "@/assets/tour-banteay-srei-hero.jpg";
import siemReap2Kampong from "@/assets/tour-kampong-phluk-kids.jpg";
import siemReap2Kulen from "@/assets/tour-phnom-kulen-holy-water.jpg";
import siemReap3KulenPhluk from "@/assets/tour-siem-reap-3day-kulen-phluk.jpg";
import siemReap4BengMealea from "@/assets/tour-siem-reap-4day-kulen-phluk-bengmealea.jpg";
import monkBlessing from "@/assets/tour-monk-blessing-village.jpg";
import oxcartVillage from "@/assets/cambodia-countryside-experience.jpg";
import homestayFarm from "@/assets/tour-homestay-farm.jpg";
import prekToal from "@/assets/birdwatching-cambodia-tour.jpg";
import prekToalHomestay from "@/assets/tour-prek-toal-homestay.jpg";
import kampongPhlukHomestay from "@/assets/tour-kampong-phluk-homestay.jpg";
import kampongKhleangHomestay from "@/assets/tour-kampong-khleang-homestay.jpg";
import phnomKulenSrahDamrei from "@/assets/tour-phnom-kulen-srah-damrei.jpg";

const imgs = [angkorSunrise, taprohm, phnomKulen, banteay, bayon, hero, guide];

const tours = [
  {
    n: "01",
    days: 1,
    title: "One Day Tours To Angkor Wat, Angkor Wat, Bayon Temple, Ta Prohm Temple ",
    sub: "Siem ReapA single, perfect dawn, 1",
    price: "From $35",
    body: "Pre-dawn departure, private access to the western causeway, breakfast among the lotus pools, and a slow read of the bas-reliefs before the day's heat.",
  },
  {
    n: "02",
    days: 1,
    title: "One Day Tours to Banteay Srei and Grand Circuit Heritage Tour",
    sub: "Siem Reap : Angkor Thom, Banteay Srei",
    price: "From $65",
    body: "Full day to Extend your Angkor adventure with visits to Banteay Srei and Grand Circuit Heritage Tours",
  },
  {
    n: "03",
    days: 1,
    title: "Phnom Kulen Waterfall, Reclining Buddha & River of 1000 Lingas ",
    sub: "Phnom Kulen, Waterfall, Preah Ang Thom",
    price: "From $85",
    body: "Explore the sacred beauty of Phnom Kulen National Park – giant Buddha, ancient river carvings, and a stunning waterfall.",
  },
  {
    n: "04",
    days: 4,
    title: "Siem Reap Tour, Angkor Wat Tour, 4 Day Itinerary",
    sub: "Angkor Wat · Phnom Kulen · Banteay Srei · Kampong Khleang",
    price: "From $415",
    body: "Four unhurried days through Angkor Wat at sunrise, the sacred mountain of Phnom Kulen, the rose-pink carvings of Banteay Srei, and the stilt-house life of Kampong Khleang on Tonlé Sap.",
  },
  {
    n: "05",
    days: 3,
    title: "Three Day Siem Reap Temple & Local Experience Tour",
    sub: "From Temple to Coast",
    price: "From $315",
    body: "Discover hidden jungle temples, ancient river carvings, and the earliest Angkorian capitals.",
  },
  {
    n: "06",
    days: 7,
    title: "7 Days Tours Across Cambodia",
    sub: "Cambodia",
    price: "From $510",
    body: "Discover the wonders of Angkor Wat, explore the countryside and floating villages at Kampong Phluk, and enjoy nature at Phnom Kulen National Park ...",
  },
  {
    n: "07",
    days: 10,
    title: "10 Days Tours Across Cambodia",
    sub: "Banteay Chhmar – Battambang – Phnom Penh",
    price: "From $915",
    body: "Discover Cambodia's highlights on this 10-day journey, from the world-famous temples of Angkor Wat to remote heritage sites, floating villages, countryside life, and the vibrant capital Phnom Penh.",
  },
  {
    n: "08",
    days: 18,
    title: "18 Days Tours Across Cambodia",
    sub: "Siem Reap – Banteay Chhmar – Battambang – Kampong Cham – Kratie – Kampot – Phnom Penh",
    price: "From $1,915",
    body: "An 18-day grand discovery: Angkor Wat, floating villages, Prek Toal birdlife, remote heritage at Banteay Chhmar, Mekong towns, Irrawaddy dolphins at Kratie, and the pepper coast of Kampot — ending in Phnom Penh.",
  },
  {
    n: "09",
    days: 21,
    title: "21 Days Tours Across Cambodia",
    sub: "Siem Reap – Preah Vihear – Mondulkiri – Kampot – Islands",
    price: "From $2,350",
    body: "The ultimate Cambodia experience: Angkor, Preah Vihear, Battambang, Phnom Penh, elephant sanctuaries in Mondulkiri, the pepper coast of Kampot and tropical island getaways at Koh Rong Sanloem.",
  },
  {
    n: "10",
    days: 25,
    title: "25 Days Tours Across Cambodia",
    sub: "Siem Reap – Banteay Chhmar – Battambang – Kampong Cham – Kratie – Ratanakiri – Mondulkiri – Kampot – Koh Rong – Phnom Penh",
    price: "From $2,650",
    body: "Discover Cambodia in depth over 25 days — from the temples of Angkor to remote jungle provinces, Mekong dolphins at Kratie, elephant forests of Mondulkiri, the pepper coast of Kampot and the tropical beaches of Koh Rong, ending in Phnom Penh.",
  },
  {
    n: "11",
    days: 30,
    title: "30-Day Ultimate Cambodia Adventure",
    sub: "Every Province, Every Experience",
    price: "From $3,215",
    body: "The most comprehensive Cambodia tour available — Angkor, Preah Vihear, Banteay Chhmar, Battambang, Phnom Penh, Mondulkiri elephants, Ratanakiri's volcanic lakes, the pepper coast of Kampot and the southern islands.",
  },
  {
    n: "12",
    days: 2,
    title: "2-Day Siem Reap Tour: Angkor Temples & Kampong Phluk",
    sub: "From Temple to Coast",
    price: "From $95",
    body: "The full sojourn. Kep's pepper coast, Bokor's mountain mists, the Mekong by riverboat, and a fortnight residency in a Siem Reap villa.",
  },
  {
    n: "13",
    days: 2,
    title: "2 Days Tour in Siem Reap: Angkor Wat & Kampong Phluk",
    sub: "Angkor Wat & Floating Village",
    price: "From $95",
    body: "Explore the majesty of Angkor Wat at sunrise and the unique stilt-house life of Kampong Phluk floating village.",
  },
  {
    n: "14",
    days: 2,
    title: "2 Days Tour in Siem Reap: Angkor Wat & Phnom Kulen holly Water",
    sub: "Angkor Wat & Holy Mountain",
    price: "From $120",
    body: "Sunrise at Angkor Wat and the great temples on Day 1, then up to Phnom Kulen for the River of a Thousand Lingas, Reclining Buddha and Kulen Waterfall.",
  },
  {
    n: "15",
    days: 3,
    title: "3 Days Tour in Siem Reap: Angkor Wat, Phnom Kulen & Kampong Phluk",
    sub: "Angkor · Holy Mountain · Floating Village",
    price: "From $180",
    body: "Three days through the best of Siem Reap — sunrise at Angkor Wat, the sacred mountain of Phnom Kulen with waterfalls and holy river, and stilt-house life at Kampong Phluk on Tonlé Sap.",
  },
  {
    n: "16",
    days: 4,
    title: "4 Days Tour in Siem Reap: Angkor Wat, Phnom Kulen, Kampong Phluk, Beng Mealea & Banteay Srei temple",
    sub: "Angkor · Kulen · Phluk · Beng Mealea",
    price: "From $235",
    body: "Four unforgettable days through the very best of Siem Reap — Angkor temples, the holy mountain of Phnom Kulen, floating-village life at Kampong Phluk, and the remote ruins of Banteay Srei and Beng Mealea.",
  },
  {
    n: "17",
    days: 0.5,
    title: "Khmer Village Tour with Monk Blessing Experience",
    sub: "Half-Day · Pagoda · Chreav Commune · Rice Spirit Tasting",
    price: "From $95",
    body: "A half-day cultural immersion — receive a monk blessing at a serene pagoda, walk Chreav Commune's stilt-house village, visit a local market and taste homemade rice spirits with Khmer snacks.",
  },
  {
    n: "18",
    days: 0.5,
    title: "Village Life Tour with Ox-Cart Ride and Farm Activities",
    sub: "Chreav Village · Authentic Farming Experience",
    price: "From $95",
    body: "Walk a working rice village in Chreav, ride a traditional ox-cart through the paddies, watch a rice-milling demonstration and share coconut juice and Khmer snacks at a local home.",
  },
  {
    n: "19",
    days: 2,
    title: "Life Farm Homestay with Khmer Family – 2 Days / 1 Night",
    sub: "Chreav Village · Authentic Cultural Stay",
    price: "From $279",
    body: "Immerse yourself in authentic Khmer life with an overnight stay at a local family's farm in Chreav village. Experience farming activities, home-cooked meals, and the warm hospitality of the countryside.",
  },
  {
    n: "20",
    days: 1,
    title: "Prek Toal Floating Village & Bird Watching Sanctuary Tour",
    sub: "Tonlé Sap · Ramsar Wetlands · 150+ Bird Species",
    price: "From $240",
    body: "A spectacular Ramsar site on the Tonlé Sap — flooded swamp forest, the largest breeding colony of large waterbirds in Southeast Asia, plus a floating village and community lunch.",
  },
  {
    n: "21",
    days: 2,
    title: "2 Days / 1 Night Overnight Floating Home Stay at Prek Toal Floating Village & Bird Watching Sanctuary Tour",
    sub: "Tonlé Sap · Floating Homestay · Bird Sanctuary",
    price: "From $387",
    body: "Experience Prek Toal Bird Sanctuary with an overnight stay in a floating village on Tonlé Sap Lake, sunset and sunrise birdwatching, flooded forest exploration, and local community hospitality.",
  },
  {
    n: "22",
    days: 2,
    title: "2 Days / 1 Night Overnight Floating Home Stay at Kampong Phluk Floating Village",
    sub: "Tonlé Sap · Stilt Houses · Sunset & Sunrise",
    price: "From $340",
    body: "Experience authentic lake life at Kampong Phluk on the edge of Tonle Sap. Stay overnight in a local homestay, explore stilt houses, cruise through flooded forests, and enjoy peaceful sunset and sunrise over the water.",
  },
  {
    n: "23",
    days: 2,
    title: "2 Days / 1 Night Overnight Floating Home Stay at Kampong Khleang Floating Village",
    sub: "Tonlé Sap · Towering Stilt Houses · Authentic Homestay",
    price: "From $385",
    body: "Experience one of the largest and most authentic stilted communities on Tonle Sap. Stay overnight in a local homestay, explore towering stilt houses, cruise through flooded forests, and enjoy peaceful rural life away from tourist crowds.",
  },
  {
    n: "24",
    days: 2,
    title: "2 Days / 1 Night Overnight at Phnom Kulen Visit (Srah Damrei temple), Waterfall, 1000 Lingas & Bat Cave Tour",
    sub: "Phnom Kulen · Srah Damrei · 1000 Lingas · Bat Cave",
    price: "From $350",
    body: "Discover Cambodia's sacred mountain — the ancient Srah Damrei stone elephants, the River of 1000 Lingas, a swim at Kulen Waterfall, and a sunset bat cave spectacle, with an overnight in the jungle.",
  },
];

const PER_PAGE = 4;

const ToursPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [q, setQ] = useState(searchParams.get("q") ?? "");
  const [duration, setDuration] = useState(searchParams.get("duration") ?? "");
  const [page, setPage] = useState(0);

  useEffect(() => {
    setQ(searchParams.get("q") ?? "");
    setDuration(searchParams.get("duration") ?? "");
    setPage(0);
  }, [searchParams]);

  const matchesDuration = (days: number) => {
    if (!duration) return true;
    if (duration === "0.5") return days === 0.5;
    if (duration === "5-7") return days >= 5 && days <= 7;
    if (duration === "8-14") return days >= 8 && days <= 14;
    if (duration === "15+") return days >= 15;
    return days === Number(duration);
  };

  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return tours.filter((t) => {
      if (!matchesDuration(t.days)) return false;
      if (!needle) return true;
      return (
        t.title.toLowerCase().includes(needle) ||
        t.sub.toLowerCase().includes(needle) ||
        t.body.toLowerCase().includes(needle)
      );
    });
  }, [q, duration]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PER_PAGE));
  const start = page * PER_PAGE;
  const visible = filtered.slice(start, start + PER_PAGE);

  const applyFilters = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (q.trim()) params.set("q", q.trim());
    if (duration) params.set("duration", duration);
    setSearchParams(params);
    setPage(0);
  };

  const clearFilters = () => {
    setQ("");
    setDuration("");
    setSearchParams(new URLSearchParams());
    setPage(0);
  };

  const goTo = (p: number) => {
    setPage(p);
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <main className="bg-background overflow-x-hidden">
      <header className="relative bg-jungle text-background overflow-hidden">
        <img
          src={toursHero}
          alt="Cambodia tours and itineraries — private French-speaking guide in Siem Reap, silver bowl with lotus petals"
          width={1920}
          height={1280}
          className="absolute inset-0 h-full w-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-jungle/70 via-jungle/50 to-jungle/90" />
        <div className="relative z-10">
          <div className="container flex items-center justify-between py-6">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-display text-2xl tracking-wide">Aṅkor</span>
              <span className="text-[10px] uppercase tracking-[0.3em] opacity-70 hidden sm:inline">Sojourns</span>
            </Link>
            <Link to="/" className="text-[11px] uppercase tracking-[0.3em] border-b border-background/40 pb-1 hover:border-primary hover:text-primary transition-colors">
              ← Return Home
            </Link>
          </div>
          <div className="container pt-20 pb-32 md:pt-28 md:pb-44 max-w-5xl">
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— The Full Atlas</p>
            <h1 className="font-display text-5xl md:text-7xl leading-[0.95] text-balance lg:text-3xl">
              Twelve sojourns, <em className="font-light">one</em> day to thirty.
            </h1>
            <p className="mt-10 max-w-xl text-background/70 font-light leading-relaxed text-base">
              From a single dawn at Angkor Wat to a month tracing the Khmer empire from coast to highland. Every journey is privately guided and capped at eight travellers.
            </p>
          </div>
        </div>
      </header>

      <section className="py-24 md:py-32">
        <div className="container">
          <form
            onSubmit={applyFilters}
            className="mb-10 bg-secondary/40 border border-border p-3 grid grid-cols-1 md:grid-cols-[1fr_auto_auto_auto] gap-2"
          >
            <input
              type="text"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search tours — Angkor, Kulen, floating village…"
              aria-label="Search tours"
              className="px-4 py-3 text-sm text-foreground bg-background placeholder:text-muted-foreground focus:outline-none border border-border md:border-0"
            />
            <select
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              aria-label="Filter by duration"
              className="px-4 py-3 text-xs uppercase tracking-[0.2em] text-foreground bg-background border border-border md:border-0 focus:outline-none"
            >
              <option value="">All durations</option>
              <option value="0.5">Half day</option>
              <option value="1">1 day</option>
              <option value="2">2 days</option>
              <option value="3">3 days</option>
              <option value="4">4 days</option>
              <option value="5-7">5–7 days</option>
              <option value="8-14">8–14 days</option>
              <option value="15+">15+ days</option>
            </select>
            <button
              type="submit"
              className="bg-foreground text-background px-6 py-3 text-xs uppercase tracking-[0.3em] hover:bg-primary transition-colors"
            >
              Search
            </button>
            <button
              type="button"
              onClick={clearFilters}
              className="px-6 py-3 text-xs uppercase tracking-[0.3em] border border-border hover:bg-background transition-colors"
            >
              Clear
            </button>
          </form>

          <div className="flex items-center justify-between mb-12">
            <p className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">
              Page {page + 1} / {totalPages} · {filtered.length} {filtered.length === 1 ? "sojourn" : "sojourns"}
            </p>
          </div>
          
          {filtered.length === 0 && (
            <p className="text-center text-muted-foreground py-20">No tours match your search. Try clearing filters.</p>
          )}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16">
            {visible.map((t, i) => (
              <article key={t.n} className="group">
                <div className="relative overflow-hidden mb-6 aspect-[4/5] bg-secondary shadow-soft">
                  <img
                    src={t.n === "02" ? banteaySrei : t.n === "04" ? bayon : t.n === "05" ? oxcart : t.n === "06" ? taprohmTree : t.n === "07" ? treeRoots : t.n === "08" ? monks18 : t.n === "09" ? beach21 : t.n === "10" ? sunset25 : t.n === "12" ? siemReap2 : t.n === "13" ? siemReap2Kampong : t.n === "14" ? siemReap2Kulen : t.n === "15" ? siemReap3KulenPhluk : t.n === "16" ? siemReap4BengMealea : t.n === "17" ? monkBlessing : t.n === "18" ? oxcartVillage : t.n === "19" ? homestayFarm : t.n === "20" ? prekToal : t.n === "21" ? prekToalHomestay : t.n === "22" ? kampongPhlukHomestay : t.n === "23" ? kampongKhleangHomestay : t.n === "24" ? phnomKulenSrahDamrei : imgs[(start + i) % imgs.length]}
                    alt={t.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                  />
                  <span className="absolute top-5 left-5 font-display text-3xl text-background">{t.n}</span>
                  <span className="absolute bottom-5 right-5 text-[10px] uppercase tracking-[0.3em] backdrop-blur px-3 py-1.5 text-background bg-foreground/40">
                    {t.days === 0.5 ? "0.5 Day" : t.days} {t.days === 1 || t.days === 0.5 ? "Day" : "Days"}
                  </span>
                </div>
                <p className="text-[11px] uppercase tracking-[0.3em] text-primary mb-2">{t.sub}</p>
                <h3 className="font-display text-3xl mb-3 md:text-xl">{t.title}</h3>
                
                <div className="flex items-center justify-between border-t border-border pt-4">
                  <span className="text-sm">{t.price}</span>
                  {(() => {
                    const itineraries: Record<string, string> = {
                      "01": "/tours/one-day-angkor-wat",
                      "02": "/tours/banteay-srei-grand-circuit",
                      "03": "/tours/phnom-kulen-waterfall",
                      "04": "/tours/siem-reap-4-day",
                      "05": "/tours/siem-reap-three-day",
                      "06": "/tours/cambodia-7-day",
                      "07": "/tours/cambodia-10-day",
                      "08": "/tours/cambodia-18-day",
                      "09": "/tours/cambodia-21-day",
                      "10": "/tours/cambodia-25-day",
                      "11": "/tours/cambodia-30-day",
                      "12": "/tours/siem-reap-2-day",
                      "13": "/tours/siem-reap-2-day",
                      "14": "/tours/siem-reap-2-day-kulen",
                      "15": "/tours/siem-reap-3-day-kulen-phluk",
                      "16": "/tours/siem-reap-4-day-beng-mealea",
                      "17": "/tours/khmer-village-monk-blessing",
                      "18": "/tours/village-oxcart-farm",
                      "19": "/tours/life-farm-homestay",
                      "20": "/tours/prek-toal-bird-sanctuary",
                      "21": "/tours/prek-toal-homestay",
                      "22": "/tours/kampong-phluk-homestay",
                      "23": "/tours/kampong-khleang-homestay",
                      "24": "/tours/phnom-kulen-srah-damrei",
                    };
                    const href = itineraries[t.n] ?? "/#contact";
                    const label = ["13","14","15","16","17","18","19","20","21","22","23","24"].includes(t.n) ? "View Itinerary Details →" : itineraries[t.n] ? "View Itinerary →" : "Inquire →";
                    return (
                      <Link to={href} className="text-[11px] uppercase tracking-[0.3em] text-foreground hover:text-primary transition-colors">
                        {label}
                      </Link>
                    );
                  })()}
                </div>
              </article>
            ))}
          </div>

          {/* PAGINATION */}
          <nav aria-label="Tours pagination" className="mt-20 flex flex-wrap items-center justify-between gap-6 border-t border-border pt-10">
            <button
              onClick={() => goTo(Math.max(0, page - 1))}
              disabled={page === 0}
              className="text-[11px] uppercase tracking-[0.3em] text-foreground hover:text-primary transition-colors disabled:opacity-30 disabled:pointer-events-none"
            >
              ← Previous
            </button>
            <ol className="flex items-center gap-3">
              {Array.from({ length: totalPages }).map((_, p) => {
                const isActive = p === page;
                return (
                  <li key={p}>
                    <button
                      onClick={() => goTo(p)}
                      aria-current={isActive ? "page" : undefined}
                      className={`font-display tabular-nums text-lg w-9 h-9 flex items-center justify-center transition-colors ${
                        isActive ? "text-primary border-b-2 border-primary text-xl" : "text-muted-foreground hover:text-foreground"
                      }`}
                    >
                      {String(p + 1).padStart(2, "0")}
                    </button>
                  </li>
                );
              })}
            </ol>
            <button
              onClick={() => goTo(Math.min(totalPages - 1, page + 1))}
              disabled={page === totalPages - 1}
              className="text-[11px] uppercase tracking-[0.3em] text-foreground hover:text-primary transition-colors disabled:opacity-30 disabled:pointer-events-none"
            >
              Next →
            </button>
          </nav>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default ToursPage;
